<template>
	<el-card id="userMessage">
		<div>
			<span class="f14 title">{{userName}}</span>
			<div class="userContent">
				<span class="f12 color999">当前账户：{{userNumber}}</span>
			</div>
		</div>
		<div class="messageCenter" @click.stop='handleJumpChange'>
			<span class="icon">
				<i class="el-icon-setting color999"></i>
			</span>
			<span class="content title" >个人设置</span>
		</div>
		<div class="signOut f14 title" @click='signOut'>
			<span>退出</span>
		</div>
	</el-card>
</template>
<script>
	export default {
		data() {
			return {
				datas:{},
				userMessage:[],
			}
		},
		created() {
			
		},
		computed:{
			userName() {
				return this.$getSessionStorage('userMssage_name');
			},
			userNumber() {
				return this.$getSessionStorage('userMssage_number');
			}
		},
		methods: {
			// 退出登录
			signOut() {
				this.$http.post('sys/login/exit',{}).then(res=>{
					let data = res.data.msg;
					sessionStorage.clear();
					this.$store.commit('CLEARROUTER');
					this.$store.commit('CLEAR_SUBJEXT_STATE');
					this.$store.commit('DEL_ALL_VISITED_VIEWS');
					this.$store.commit('DEL_ALL_CACHED_VIEWS');
					this.$store.commit('CLEAR_YEARPERIODS_INFO');
					if(data.length>4) {
						let sliceData = data.slice(0,4);
						if(sliceData == "http") {
							location.href = data;
						}else {
							this.$router.push({
								path: '/login'
							})
						}
					}else {
						this.$router.push({
							path: '/login'
						})
					}
					
					
				})
			},
			handleJumpChange() {
				this.$emit('closeDialog',true)
				if(this.$route.path==="/personalSettings"){
					return this.$message.warning("当前您已在个人设置页面")
				};
				this.$router.push({path: '/personalSettings'})
			},
		},
	}
</script>
<style lang="less">
	#userMessage {
		.title {
			color: #333;
			font-weight: 600;
		}
		.userContent {
			padding: 10px 0 30px 0;
			position: relative;
			.set {
				position: absolute;
				right: 0;
				font-size: 18px;
				cursor: pointer;
			}
		}
		.messageCenter {
			cursor: pointer;
			border-bottom: 1px solid #EEEEEE;
			border-top: 1px solid #EEEEEE;
			padding: 30px 0;
			display: flex;
			user-select: none;
			justify-content: flex-start;
			 align-items: center;
			.content{
				margin-left: 20px;
				font-size: 14px;
			}
			.icon {
				i{
					font-size: 20px;
				}
			}
			.num {
				font-size: 12px;
				color: #D0021B;
				margin-left: 115px;
			}
		}
		.signOut {
			text-align: center;
			padding: 30px 0 10px 0;
			cursor: pointer;
			color: #D0021B;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/dialog/userMessage.vue